import { nanoid } from 'nanoid';
import { FixedRatios, INTEGRATION_TYPES } from '@model';
import { saveTextContainerTemplate } from '@service/apis';
import { isHtmlModuleEnabled } from '@utils/htmlModuleConfig';
export const addDefaultKey = async (
  type,
  isModule,
  ratioNeedFullSize = false,
) => {
  switch (type) {
    case 'pdf':
      if (isModule) {
        return {
          iframe: true,
          type: 'pdf',
          clientPermissions: [],
          internalPermissions: [],
          originPermissions: [],
          value: nanoid(),
          icon: 'kpi',
        };
      }
      return { iframe: true, type: 'pdf' };
    case 'image':
      return { iframe: true, type: 'image' };
    case 'powerbi':
      return { iframe: false, type: 'powerbi' };
    case 'imageModule':
      return {
        iframe: true,
        type: 'imageModule',
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        icon: 'bubble-plot',
      };
    case INTEGRATION_TYPES.HTML:
      if (!isHtmlModuleEnabled()) {
        return {
          iframe: false,
          type: 'regular',
          clientPermissions: [],
          internalPermissions: [],
          originPermissions: [],
          value: nanoid(),
          icon: 'engagement',
        };
      }
      return {
        iframe: true,
        type: INTEGRATION_TYPES.HTML,
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        icon: 'engagement',
        link: '',
      };
    case 'powerbiModule':
      return {
        iframe: true,
        type: 'powerbiModule',
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        icon: 'powerbi',
      };
    case 'regular':
      return {
        iframe: false,
        type: 'regular',
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        icon: 'engagement',
      };
    case 'widget':
      return {
        iframe: false,
        type: 'widget',
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        link: 'empty-widget',
        icon: 'spider-chart',
      };
    case 'multiSection':
      return {
        iframe: false,
        type: 'multiSection',
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        link: 'empty-multiSection',
        icon: 'speedometer',
      };
    case INTEGRATION_TYPES.M365:
      return {
        iframe: true,
        type: INTEGRATION_TYPES.M365,
        clientPermissions: [],
        internalPermissions: [],
        originPermissions: [],
        value: nanoid(),
        link: '',
      };
    case 'text':
      return {
        type: 'text',
      };
    case 'chart':
      return {
        type: 'chart',
        iframe: false,
      };
    case INTEGRATION_TYPES.TEXT_CONTAINER:
      return await generateTextContainerDefaultData(
        ratioNeedFullSize,
        isModule,
      );

    default:
      return null;
  }
};

async function generateTextContainerDefaultData(ratioNeedFullSize, isModule) {
  const defaultData = {
    type: INTEGRATION_TYPES.TEXT_CONTAINER,
    iframe: false,
    icon: 'survey',
    // 部分页面默认值要full size，其他页面要banner
    ratio: ratioNeedFullSize ? FixedRatios.FULL : FixedRatios.BANNER,
    ...(isModule
      ? {
          originPermissions: [],
          clientPermissions: [],
          internalPermissions: [],
          value: nanoid(),
          link: '',
        }
      : {}),
  };
  if (window.location.href.includes('systemModule')) {
    const res = await saveTextContainerTemplate({ data: '[]' });
    if (res.data.id) {
      defaultData.link = res.data.id;
    }
    return defaultData;
  }
  return defaultData;
}
